import {
  IGetOfficePlanDetailApiResponse,
  IGetOfficePlanDetailResult,
  IGetPostingPlansApiResponse,
  IGetPostingPlansResult,
  IOfficePlanDetailEntity,
  IPostingPlanApiModel,
  IPostingPlanViewEntity,
} from '../types';

const toPostingPlanViewEntity = (model: IPostingPlanApiModel): IPostingPlanViewEntity => {
  return {
    id: model.id,
    name: model.name,
    description: model.description,
    basePrice: model.basePrice,
    finalPrice: model.finalPrice,
    nextBillingDate: model.nextBillingDate,
    createdAt: model.createdAt,
    updatedAt: model.updatedAt,
    billingInterval: model.billingInterval,
    intervalCount: model.intervalCount,
  };
};

const toGetPostingPlansResult = (response: IGetPostingPlansApiResponse): IGetPostingPlansResult => {
  return {
    data: response.data.map(toPostingPlanViewEntity),
  };
};

const toOfficePlanDetailEntity = (
  response: IGetOfficePlanDetailApiResponse,
): IOfficePlanDetailEntity => {
  return {
    id: response.id,
    officeId: response.officeId,
    planId: response.planId,
    planName: response.planName,
    postingId: response.postingId,
    status: response.status,
    price: response.price,
    billingInterval: response.billingInterval,
    billingIntervalCount: response.billingIntervalCount,
    gracePeriodDays: response.gracePeriodDays,
    suspendedAt: response.suspendedAt,
    gracePeriodEndsAt: response.gracePeriodEndsAt,
    createdAt: response.createdAt,
    updatedAt: response.updatedAt,
  };
};

const toGetOfficePlanDetailResult = (
  response: IGetOfficePlanDetailApiResponse,
): IGetOfficePlanDetailResult => {
  return {
    data: toOfficePlanDetailEntity(response),
  };
};

export const PostingPlanAdapters = {
  toGetOfficePlanDetailResult,
  toGetPostingPlansResult,
  toOfficePlanDetailEntity,
  toPostingPlanViewEntity,
};
